<template>
  <div style="width: 100%;height: 100%">
    <img v-show="!isShowVideo" style="width: 100%;height: 100%;object-fit: none" src="../../assets/load.gif">
    <div v-show="isShowVideo" style="width: 100%;height: 100%">
      <ysy-video v-if="type === 'ysy'" ref="ysyVideo" :videoObj="videoObj" @startSuccess="startSuccess"></ysy-video>
    </div>
  </div>
</template>

<script>
import ysyVideo from './components/ysyVideo'
export default {
  name: 'index',
  components: {ysyVideo},
  data () {
    return {
      isShowVideo: true,
      // 萤石云ysy
      type: '',
      videoObj: null
    }
  },
  methods: {
    startVideo (videoObj) {
      // let that = this
      this.type = videoObj.videoType
      this.videoObj = videoObj
      // if (this.type === 'ysy') {
      //   setTimeout(function () {
      //     that.$refs.ysyVideo.startVideo(videoObj)
      //   }, 100)
      // }
    },
    async closeVideo (videoObj) {
      if (this.type === 'ysy') {
        await this.$refs.ysyVideo.closeVideo(videoObj)
      }
    },

    startSuccess () {
      this.isShowVideo = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/videoComponent/index.vue